import useViewportHeight from "./Hooks/useViewportHeight";
import { useAppContext } from "./Context/AppContext/AppContext";
import { ConfigProvider } from "antd";
import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Routing from "./Routing/Index";
import AILoader from "./Components/AILoader/AILoader";
import { useAILoader } from "./Context/AILoaderContext/AILoaderContext";
import Loader from "./Components/Loader/Index";
import { useLoader } from "./Context/LoaderContext/LoaderContext";
import InitialLoader from "./Components/InitialLoader/InitialLoader";
import NetworkStatusWrapper from "./Components/NetworkStatusWrapper/NetworkStatusWrapper";
import NoOrganization from "./Components/NoOrganization/NoOrganization";
import { Analytics } from "./Components/Analytics";
import "./App.css";

function App() {
  const { customisedTheme, appInitialized, organization } = useAppContext();
  const { isShowAILoader, aiLoaderText } = useAILoader();
  const { isLoading, loadingMessage } = useLoader();
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    if (appInitialized) {
      const timeout = setTimeout(() => setShowLoader(false), 500);
      return () => clearTimeout(timeout);
    } else {
      setShowLoader(true);
    }
  }, [appInitialized]);

  useViewportHeight();

  return (
    <ConfigProvider theme={customisedTheme}>
      <Analytics />
      <BrowserRouter>
        <AILoader isShowAILoader={isShowAILoader} aiLoaderText={aiLoaderText} />
        <Loader isLoading={isLoading} loadingMessage={loadingMessage} />
        <NetworkStatusWrapper>
          {showLoader ? (
            <InitialLoader />
          ) : organization ? (
            <Routing />
          ) : (
            <NoOrganization />
          )}
        </NetworkStatusWrapper>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
